var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNineDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.9697C0 1.32958 1.32958 0 2.9697 0C4.60982 0 5.93939 1.32958 5.93939 2.9697C5.93939 4.60982 4.60982 5.93939 2.9697 5.93939C1.32958 5.93939 0 4.60982 0 2.9697Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 12.3599 1.32958 11.0303 2.9697 11.0303C4.60982 11.0303 5.93939 12.3599 5.93939 14C5.93939 15.6401 4.60982 16.9697 2.9697 16.9697C1.32958 16.9697 0 15.6401 0 14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.0303C0 23.3902 1.32958 22.0606 2.9697 22.0606C4.60982 22.0606 5.93939 23.3902 5.93939 25.0303C5.93939 26.6704 4.60982 28 2.9697 28C1.32958 28 0 26.6704 0 25.0303Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0303 2.9697C11.0303 1.32958 12.3599 0 14 0C15.6401 0 16.9697 1.32958 16.9697 2.9697C16.9697 4.60982 15.6401 5.93939 14 5.93939C12.3599 5.93939 11.0303 4.60982 11.0303 2.9697Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0303 14C11.0303 12.3599 12.3599 11.0303 14 11.0303C15.6401 11.0303 16.9697 12.3599 16.9697 14C16.9697 15.6401 15.6401 16.9697 14 16.9697C12.3599 16.9697 11.0303 15.6401 11.0303 14Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0303 25.0303C11.0303 23.3902 12.3599 22.0606 14 22.0606C15.6401 22.0606 16.9697 23.3902 16.9697 25.0303C16.9697 26.6704 15.6401 28 14 28C12.3599 28 11.0303 26.6704 11.0303 25.0303Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0606 2.9697C22.0606 1.32958 23.3902 0 25.0303 0C26.6704 0 28 1.32958 28 2.9697C28 4.60982 26.6704 5.93939 25.0303 5.93939C23.3902 5.93939 22.0606 4.60982 22.0606 2.9697Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0606 14C22.0606 12.3599 23.3902 11.0303 25.0303 11.0303C26.6704 11.0303 28 12.3599 28 14C28 15.6401 26.6704 16.9697 25.0303 16.9697C23.3902 16.9697 22.0606 15.6401 22.0606 14Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0606 25.0303C22.0606 23.3902 23.3902 22.0606 25.0303 22.0606C26.6704 22.0606 28 23.3902 28 25.0303C28 26.6704 26.6704 28 25.0303 28C23.3902 28 22.0606 26.6704 22.0606 25.0303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineDots);
export default __webpack_public_path__ + "static/media/nine-dots.236f53ad72fb3589984ae2d483723db9.svg";
export { ForwardRef as ReactComponent };